import { FunctionComponent, ReactElement } from "react";
import "./NewConnection.scss";
import { getParamFromUrl } from "../../utils/UrlUtils";
import { Button } from "@screencloud/screencloud-ui-components";

const startAuthFlow = async () => {
  try {
    const token = getParamFromUrl("token");
    const provider = getParamFromUrl("provider");
    const appName = getParamFromUrl("appName");
    const appConfigId = getParamFromUrl("appConfigId");
    const newAccountRedirectUrl = `${process.env.REACT_APP_API_BASE_URL}/auth/begin?token=${token}&appConfigId=${appConfigId}&provider=${provider}&appName=${appName}`;
    window.location.href = newAccountRedirectUrl;
  } catch (error) {
    console.log(error);
  }
};

export const NewConnection: FunctionComponent<{}> = (): ReactElement<{}> => {
  return (
    <div className={"new-connection"}>
      <div className={"new-connection_button"}>
        <Button primary onClick={startAuthFlow}>
          Login
        </Button>
      </div>
    </div>
  );
};
